<template>
  <v-row class="fill-height">
    <v-col>
      <v-card flat>
        <v-row class="nopadding">
          <v-col>
            <v-toolbar flat>
              <v-btn
                outlined
                class="mr-4"
                color="grey darken-2"
                @click="setToday"
              >
                今日
              </v-btn>
              <v-menu bottom transition="slide-y-transition" right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    outlined
                    color="grey darken-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <span>{{ typeToLabel[type] }}</span>
                    <v-icon right> mdi-menu-down </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="type = 'day'">
                    <v-list-item-title>Day</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'week'">
                    <v-list-item-title>Week</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'month'">
                    <v-list-item-title>Month</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = '4day'">
                    <v-list-item-title>4 days</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-spacer></v-spacer>

              <v-btn fab text small color="grey darken-2" @click="prev">
                <v-icon x-large> mdi-chevron-left </v-icon>
              </v-btn>
              <v-toolbar-title v-if="$refs.calendar">
                <h2>{{ this.calendarTitle }}</h2>
              </v-toolbar-title>
              <v-btn fab text small color="grey darken-2" @click="next">
                <v-icon x-large> mdi-chevron-right </v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <ryou-blue-btn :label="'新規追加'" :handlerClick="handleAdd">
              </ryou-blue-btn>
            </v-toolbar>
          </v-col>
        </v-row>
      </v-card>
      <v-container>
        <v-sheet height="600">
          <!--<v-calendar ref="calendar"
                      v-model="focus"
                      color="primary"
                      :events="events"
                      :event-color="getEventColor"
                      :type="type"
                      @click:event="showEvent"
                      @click:more="viewDay"
                      @click:date="viewDay"
                      @change="updateRange"></v-calendar>-->
          <v-calendar
            ref="calendar"
            v-model="focus"
            color="primary"
            :events="events"
            :event-color="getEventColor"
            :type="type"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
            @change="updateRange"
          ></v-calendar>
          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-y
          >
            <calendar-event-dialog
              ref="calendarEventDialog"
              :eventFromParent="selectedEvent"
              :closeFromParent="eventDetailClose"
              :getGeneralFunc="getGeneralFunc"
            ></calendar-event-dialog>
          </v-menu>
        </v-sheet>
      </v-container>
      <v-dialog v-model="dialog" persistent max-width="700px">
        <div>
          <calendar-event-dialog
            ref="addCalendarEventDialog"
            :eventFromParent="dummyEvent"
            :closeFromParent="dialogClose"
            :getGeneralFunc="getGeneralFunc"
          ></calendar-event-dialog>
        </div>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import CalendarEventDialog from "./CalendarEventDialog.vue";
import RyouBlueBtn from "@/components/formInput/RyouBlueBtn.vue";

export default {
  components: {
    CalendarEventDialog,
    RyouBlueBtn,
  },
  props: {
    getGeneralFunc: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  data: () => ({
    width: "350px",
    dialog: false, //新規追加ダイアログ
    calendarTitle: "", //カレンダータイトル
    focus: "", //選択日付
    type: "month", //カレンダータイプ
    typeToLabel: {
      //カレンダータイプリスト
      month: "Month",
      week: "Week",
      day: "Day",
      "4day": "4 Days",
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    colors: [
      "blue",
      "indigo",
      "deep-purple",
      "cyan",
      "green",
      "orange",
      "grey darken-1",
    ],
    names: [
      "Meeting",
      "Holiday",
      "PTO",
      "Travel",
      "Event",
      "Birthday",
      "Conference",
      "Party",
    ],
    dummyEvent: { color: "blue-grey lighten-3", name: "", detail: "" }, //ダミーイベント、新規追加ダイアログ表示時に渡す
  }),
  mounted() {
    //カレンダータイトルのフォーマットを変更して表示
    this.calendarTitle = this.initCalendarValue(this.$refs.calendar.title);
    this.$refs.calendar.checkChange();
  },
  methods: {
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = ""; //設定がなければ当日をフォーカスする？
    },
    prev() {
      this.$refs.calendar.prev();
      requestAnimationFrame(
        () =>
          (this.calendarTitle = this.initCalendarValue(
            this.$refs.calendar.title
          ))
      );
    },
    next() {
      this.$refs.calendar.next();
      requestAnimationFrame(
        () =>
          (this.calendarTitle = this.initCalendarValue(
            this.$refs.calendar.title
          ))
      );
    },
    //イベント詳細を閉じる
    eventDetailClose() {
      this.selectedOpen = false;
    },
    //新規追加ダイアログを閉じる
    dialogClose() {
      this.dialog = false;
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        //空気を読んで関数を実行させる
        requestAnimationFrame(() =>
          requestAnimationFrame(() => {
            this.selectedOpen = true;
          })
        );
      };

      //すでにイベントがオープンの時は、オフにしてからもう一度イベントをオープンする
      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      //現在のイベントの伝搬を止める
      nativeEvent.stopPropagation();
    },
    ///サンプルコード ランダムにイベントを作成する
    updateRange() {
      //この関数がないと、カレンダータイプ変更時にイベントの再取得がが必要になる
      //原因の調査が必要
      //デフォルトのランダムなイベント？を作成する処理は削除した
    },

    //DBからデータを取得する
    setEvents(events) {
      // console.log(events)
    },
    //カレンダーヘッドの初期化時間
    initCalendarValue(title) {
      //"12月2021"
      //"11月-12月2021"
      //"12月2021-1月2022"
      title = title.replace(/ /g, "");

      let newTitile = null;
      if (title.split("月").length == 3) {
        //["11", "-12", "2021"]
        //["12", "2021-1", "2022"]
        let firstSplitResult = title.split("月");
        let firstMonth = firstSplitResult[0];

        //["", "12"]
        //["2021", "1"]
        let secondSplitResult = firstSplitResult[1].split("-");

        if (secondSplitResult[0] != "") {
          newTitile =
            secondSplitResult[0] +
            "年" +
            firstMonth +
            "月" +
            "～" +
            secondSplitResult[1] +
            "月";
        } else {
          newTitile =
            firstSplitResult[2] +
            "年" +
            firstMonth +
            "月" +
            "～" +
            secondSplitResult[1] +
            "月";
        }
      } else {
        let titleList = title.split("月");
        newTitile = titleList[1] + "年" + titleList[0] + "月";
      }
      return newTitile;
    },
    //新規追加ボタン
    handleAdd() {
      this.dialog = true;
      this.$refs.addCalendarEventDialog.add();
    },
    //DBより作業予定を取得する
    fetchWorkSchdule(buildGroupId, buildingId, workClass) {
      const events = [];
      //作業予定一覧を取得する
      let params = {
        build_group_id: buildGroupId,
        building_id: buildingId,
        work_class: workClass,
        user_id: this.$store.getters.getUserId,
        user_Class: this.$store.getters.getUserClass,
      };
      this.getRequest(
        "/noticeWorkScheduleConfirmation/noticeConfirmationGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success && data.status == "200") {
          data.result.forEach((item) => {
            //作業日時を成型
            var date = new Date(item.work_date);
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            var start_time = item.work_start_time.split(":");
            var end_time = item.work_end_time.split(":");
            var work_start = new Date(
              year +
                "-" +
                month +
                "-" +
                day +
                " " +
                start_time[0] +
                ":" +
                start_time[1]
            );
            var work_end = new Date(
              year +
                "-" +
                month +
                "-" +
                day +
                " " +
                end_time[0] +
                ":" +
                end_time[1]
            );

            //カレンダーイベントに追加
            events.push({
              name: item.title,
              start: work_start,
              end: work_end,
              color: this.colors[item.work_class],
              timed: true,
              model: item,
            });
          });
        }
      });
      this.events = events;
      // console.log(this.events)
    },
  },
};
</script>

<style>
.nopadding {
  padding: 0px;
}

.noBotPadding {
  padding-bottom: 0px;
}

.noRigPadding {
  padding-right: 0px;
}
</style>
